export default __webpack_public_path__ + "static/media/team2.51727734.png";